import { TableUIProvider } from "../../contexts/TableUIContext";
import Teachers from "./Teachers";

export default function TeachersWrapper() {
    return (
        <TableUIProvider>
            <Teachers />
        </TableUIProvider>
    );
}
